// Barra contextual para la capa de imagen seleccionada: redondear esquinas.
// (El recorte queda como fast-follow.)
//
// "Dividir en capas" vivió acá un rato y se mudó al panel "Herramientas" del rail:
// esta barra es para propiedades de la capa (se tocan y se ven al instante), no para
// acciones que gastan créditos y tardan un minuto.

import type { ImageLayer } from '../scene/types';
import type { SceneApi } from '../scene/useScene';

interface Props {
  api: SceneApi;
}

export function ImageToolbar({ api }: Props) {
  const layer = api.selected;
  if (!layer || layer.type !== 'image') return null;
  const img = layer as ImageLayer;
  return (
    <div className="h-full flex items-center gap-3 px-3 overflow-x-auto scrollbar-hide">
      <div className="flex items-center gap-2 shrink-0">
        <span className="text-[11px] uppercase tracking-wide font-medium text-[#3C3C43]/55">Esquinas</span>
        <input
          type="range"
          min={0}
          max={50}
          value={img.radiusPct}
          onChange={(e) => api.updateLayer(img.id, { radiusPct: Number(e.target.value) })}
          onPointerDown={() => api.checkpoint()}
          className="w-40 accent-brand-primary"
        />
        <span className="w-8 text-[12px] tabular-nums text-neutral-700">{Math.round(img.radiusPct)}%</span>
      </div>
    </div>
  );
}
